document.addEventListener('DOMContentLoaded', function() {
    
    var allLinks = document.querySelectorAll('.js-brand-filter');
    var allGroups = document.querySelectorAll('.brand-group');
    var noBrandsMessage = document.getElementById('no-brands-message');
    
    function filterBrands(letter) {
        
        // 1. Aggiorna classe active sui link
        allLinks.forEach(function(link) {
            link.parentElement.classList.remove('active');
        });
        
        // Attiva il link cliccato
        var activeLink = document.querySelector('.js-brand-filter[data-letter="' + letter + '"]');
        if (activeLink) {
            activeLink.parentElement.classList.add('active');
        }

        // 2. Mostra/Nascondi gruppi
        var visibleCount = 0;

        if (letter === 'all') {
            allGroups.forEach(function(group) {
                group.style.display = 'inline-block'; // Usa inline-block per il layout a colonne
            });
            visibleCount = allGroups.length;
        } else {
            allGroups.forEach(function(group) {
                if (group.getAttribute('data-letter') === letter) {
                    group.style.display = 'inline-block';
                    visibleCount++;
                } else {
                    group.style.display = 'none';
                }
            });
        }

        // Mostra messaggio se vuoto (caso raro)
        if (noBrandsMessage) {
            noBrandsMessage.style.display = (visibleCount === 0) ? 'block' : 'none';
        }
    }

    // Event Listeners
    allLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            var selectedLetter = this.getAttribute('data-letter');
            filterBrands(selectedLetter);
        });
    });
});